<iframe [src]="fileUrl | safe: 'resourceUrl'"
        (load)="iframeLoaded()"
        width="100%"
        height="100%"></iframe>
